import { Component } from '@angular/core';

import { Location } from '@angular/common';

import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  RoutesRecognized
} from '@angular/router'
import {LoaderService} from '~common/service/loader.service'
import {AuthenticationService} from '~common/service/authentication.service'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public isLoading = true;
  public isProcessing: boolean = false
  constructor(private router: Router, public _loaderService: LoaderService, private _location: Location, private _authService:AuthenticationService) {
    _loaderService.loaderState.subscribe((state)=>{
      this.isProcessing = state.show
    })
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event)
    })
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        if(!_authService.isAuthenticated()) {
          this.router.navigate(['login']);
        }else{
          // this._location.back()
          const user = this._authService.getProfile()
          if(user.isAdmin){
            this.router.navigate(['/admin']);

          }else{
            this.router.navigate(['/']);
          }
        }
      }
    }, false)
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.isLoading = true;
    }
    if (event instanceof NavigationEnd) {
      this.isLoading = false;
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.isLoading = false;
    }
    if (event instanceof NavigationError) {
      this.isLoading = false;
    }
  }

}
